import React from 'react'
import useAuth from '../../hooks/useAuth';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { setUser } from '../../features/auth/authSlice';
import { User } from '../../features/auth/types';

const AuthInit = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuth();
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    if (!isAuthenticated) {
      const token = localStorage.getItem('token');
      if (token) {
        const userStr = localStorage.getItem('user');
        if (userStr) {
          try {
            const user: User = JSON.parse(userStr);
            dispatch(setUser({ ...user, token }));
          } catch {}
        }
      }
    }
  }, [isAuthenticated, dispatch]);
  return <>{children}</>;
}

export default AuthInit